import React from 'react';
import { ChevronRight, X } from 'lucide-react';

interface BreadcrumbsProps {
  parentCategory?: { name: string; slug: string };
  category?: { name: string; slug: string };
  article?: { title: string; slug: string };
  tags?: string[];
   onTagRemove?: (tag: string) => void;
  onHomeClick?: () => void;
  onCategoryClick?: (slug: string) => void;
 }

 export function Breadcrumbs({
  parentCategory,
  category,
  article,
  tags,
  onTagRemove,
  onHomeClick,
  onCategoryClick
}: BreadcrumbsProps) {
  return (
    <nav className="flex flex-wrap items-center text-sm text-gray-600 mb-6" role="navigation" aria-label="breadcrumb">
      <button 
        onClick={() => {
          if (onHomeClick) {
            onHomeClick();
          }
        }}
        className="hover:text-blue-600 transition-colors"
      >
        Home
      </button>
      
      {parentCategory && (
  <>
    <ChevronRight className="w-4 h-4 mx-2" />
    <button
      onClick={() => {
        if (onCategoryClick) {
          onCategoryClick(parentCategory.slug);
        }
      }}
      className="hover:text-blue-600 transition-colors"
    >
      {parentCategory.name}
    </button>
  </>
)}

      {category && (
        <>
          <ChevronRight className="w-4 h-4 mx-2" />
          <button 
            onClick={() => {
              if (onCategoryClick) {
                onCategoryClick(category.slug);
              }
            }}
            className="hover:text-blue-600 transition-colors"
          >
            {category.name}
          </button>
        </>
      )}

      {tags && tags.length > 0 && (
        <>
          <ChevronRight className="w-4 h-4 mx-2" />
          <div className="flex flex-wrap gap-2">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center bg-blue-50 text-blue-600 rounded-full px-3 py-1"
              >
                {tag}
                {onTagRemove && (
                  <button
                    onClick={() => onTagRemove(tag)}
                    className="ml-2 hover:text-blue-800 transition-colors"
                  >
                    <X className="w-3 h-3" />
                  </button>
                )}
              </span>
            ))}
          </div>
        </>
      )}

      {article && (
        <>
          <ChevronRight className="w-4 h-4 mx-2" />
          <span 
            className="text-gray-400 truncate max-w-[300px]" 
            title={article.title}
          >
            {article.title}
          </span>
        </>
      )}
    </nav>
  );
}
